module.exports = __webpack_public_path__ + "static/media/info.9cc7a87d.svg";